import { Route } from '@angular/router';
import { Error404Component } from './pages/error-404/error-404.component';
import { Error500Component } from './pages/error-500/error-500.component';

export const commonRoutes: Route[] = [
    {
        path: '404-not-found',
        pathMatch: 'full',
        component: Error404Component,
    },
    {
        path: '500-server-error',
        pathMatch: 'full',
        component: Error500Component,
    },
    { path: '**', redirectTo: '404-not-found' },
];

//Error500Component